const createWidgetFactory = require('components-framework/widget/create_widget_factory');

module.exports = createWidgetFactory({
    name: 'membership_customer_service_hotline',
    viewClass: require('./view'),
});
